import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ContentItem } from '@gnb/components/Common'
import { EumEditor, ViewFrame } from '@appbase/components/editor'
import { mapActions, mapGetters } from 'vuex'
import api from '@gnb/api/common'
import * as types from '@gnb/store/types'
import * as accountTypes from '@account/store/types'

@Component({
    components:{
        ContentItem,
        EumEditor,
        ViewFrame
    },
    computed: mapGetters({
        user: accountTypes.USER,        
        cardState: types.CARDSTATE,
        companyCards: types.COMPANY_CARD,
        freeContent: types.FREECONTENT        
    }),
    methods:{      
        ...mapActions({
            setLoading: types.COMMON_LOADDING,
            fetchSettings: types.CARDSETTINGS 
        }) 
    }
})
export default class SignatureOptionView extends Vue {
    setLoading!: (option: boolean) => void;
    fetchSettings!: () => Promise<gnb.CardResponse>;

    user!: account.User;    
    cardState!: string;
    companyCards!: gnb.CompanyCard[];
    freeContent!: string;

    mContentLoading: boolean = false;
    mCardState: string = 'NONE';
    mCardContent: string = '';
    mFreeContent: string = '';
    mCardOptions: { key: string, displayName: string }[] = [];

    synapopts: editor.synap.SynapEditorConfig = {
        'editor.autoSave': false,
        'editor.autoSave.period' : 10,
        'editor.menu.show' : true       
    }    

    @Watch('companyCards')
    onCompanyCardsChanged(newVal: gnb.CompanyCard[]) {
        this.mCardOptions = [
            { key: 'NONE', displayName: this.$t('없음').toString() },
            ...newVal.map(m => { return { key: m.id, displayName: m.templateName } }),
            { key: 'FREECONTENT', displayName: this.$t('자유명함').toString() }
        ]
    }

    created() {      
        this.mContentLoading = true;
        this.fetchSettings().finally(() => {
            if(this.mCardOptions.findIndex(o => o.key === this.cardState) >= 0) {
                this.mCardState = this.cardState;
            } else {
                this.mCardState = 'NONE';
            }
            
            this.mFreeContent = this.freeContent;
            this.mCardContent = this.getCardContent(this.mCardState);
            this.setLoading(false);
            this.$nextTick(() => {
                this.mContentLoading = false;
            })            
        });        
    }

    getEditorContent(): string {
        const editor: editor.IEditorProxy = this.$refs.editor as any 
        return editor.getEditor().getBodyValue();
    }

    getCardContent(key: string): string {        
        var template = this.companyCards.find(c => c.id === key)?.templateHtml || ''; 
        template = template.replace(/{{이름}}/g, this.user.displayName || "");
        template = template.replace(/{{이름_영문}}/g, this.user.displayNameEng || "");
        template = template.replace(/{{이름_중문}}/g, this.user.displayDeptNameCh || "");
        template = template.replace(/{{회사명}}/g, this.user.concurrenceComName || "");
        template = template.replace(/{{회사명_영문}}/g, this.user.concurrenceComNameEn || "");
        template = template.replace(/{{회사명_중문}}/g, this.user.concurrenceComNameCh || "");
        template = template.replace(/{{부서명}}/g, this.user.deptName || "");
        template = template.replace(/{{부서명_영문}}/g, this.user.deptNameEn || "");
        template = template.replace(/{{부서명_중문}}/g, this.user.deptNameCh || "");            
        template = template.replace(/{{직책}}/g, this.user.titleName || "");
        template = template.replace(/{{직책_영문}}/g, this.user.titleNameEn || "");
        template = template.replace(/{{직책_중문}}/g, this.user.titleNameCh || "");
        template = template.replace(/{{직급}}/g, this.user.gradeName || "");
        template = template.replace(/{{직급_영문}}/g, this.user.gradeNameEn || "");
        template = template.replace(/{{직급_중문}}/g, this.user.gradeNameCh || "");      
        template = template.replace(/{{주소}}/g, this.user.homeAddress || "");            
        template = template.replace(/{{사내전화번호}}/g, this.user.officeTel || "");
        template = template.replace(/{{팩스번호}}/g, this.user.officeFax || "");
        template = template.replace(/{{핸드폰번호}}/g, this.user.mobileTel || "");
        template = template.replace(/{{이메일}}/g, this.user.email || "");     
        
        return template;
    }

    onStateChanged() {    
        this.mContentLoading = true; 
        this.mCardContent = this.getCardContent(this.mCardState);

        this.$nextTick(() => {
            this.mContentLoading = false;
        });               
    }

    save(): Promise<any> {
        if(this.mCardState === 'FREECONTENT') {
            this.mFreeContent = this.getEditorContent();
        }

        return api.setUserBusinessCardState(
            this.user.personCode,
            this.mCardState,
            this.mFreeContent).then(res => {
                (window as any).alertAsync(this.$t('적용되었습니다').toString());
                return res;
        });
    }
}